<template>
  <div class="box">
    <div class="hd">工单情况分析</div>
    <div class="comments">今日单数：<span>100 </span>单</div>
    <div class="bd">
      <el-table class="table-dark" :data="tableData" style="width: 100%; height: 100%">
        <el-table-column prop="date" label="日期" width="120"></el-table-column>
        <el-table-column prop="time" label="时间" width="90"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="done" label="处理情况"></el-table-column>
      </el-table>
    </div>
    <div class="comments">已处理<span>98</span>单  未处理<span>2</span>单</div>
    <dv-decoration-2 style="height:10px;" />
  </div>
</template>

<script>
// import ecStat from 'echarts-stat'
/* eslint-disable */
export default {
  name: 'MidChart3',
  data () {
    return {
      tableData: [{
        date: '2020-04-03',
        time: '08：20',
        title: '原材料供给翻倍',
        done: '已处理'
      }, {
        date: '2020-04-03',
        time: '08：20',
        title: '原材料供给翻倍',
        done: '已处理'
      }, {
        date: '2020-04-03',
        time: '08：20',
        title: '原材料供给翻倍',
        done: '已处理'
      }, {
        date: '2020-04-03',
        time: '08：20',
        title: '原材料供给翻倍',
        done: '已处理'
      }]
    }
  },
  methods: {
    load() {
    },
  },
  mounted() {
    this.load()
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;

  .hd {
    text-align: center;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .comments {
    text-align: left;
    height: 30px;
    font-size: 20px;
    font-weight: bold;
    span {
      color:#096dd9;
      font-size: 35px;
      font-weight: bold;
    }
    margin-bottom: 10px;
  }

  .bd {
    flex:1;
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .chart {
    flex: 1;
  }
}

.el-table.table-dark {
  background-color: rgba(255, 255, 255, 0.1);
  /deep/ tr, /deep/ th {
    background-color: transparent;
  }
  /deep/ .el-table__row {
    // background-color: rgba(255, 255, 255, .2);
    color: #fff;
  }
  
  /deep/ .el-table__row.hover-row td {
    color: #fff;
    background-color: rgba(255, 255, 255, .2);
  }
  /deep/ .el-table__body tr:hover > td {
    color: #fff;
    background-color: rgba(255, 255, 255, .2);
  }
  // /deep/ .el-table__header th, .el-table__header tr {
    // background-color: rgba(255, 255, 255, .5);
    // color: #666;
  // }
}
</style>
